<template>
  <div class="min-h-dvh">
    <Error v-if="errorStatus" :errorCode="requestStatus" />
    <ThirdPartyCodeResult
      v-else-if="reportStatus"
      :decodedData="decodedData"
      :deviceInfo="deviceInfo"
      :installId="installId"
      @reopen-camera="reopenCamera"
    />
    <ErrorResults
      v-else
      :code-status="status"
      :imageQuality="imageQuality"
      :isHybrid="isHybrid"
      :photo="photo"
    />
  </div>
</template>

<script setup>
import { events } from '@/utils/events'
import { computed } from 'vue'
import Error from '@/components/Error.vue'
import ThirdPartyCodeResult from '@/components/codeResponses/ThirdPartyCodeResult.vue'
import ErrorResults from '@/components/codeResponses/ErrorResults.vue'

const props = defineProps({
  installId: String,
  status: {
    type: String,
    required: true
  },
  imageQuality: Array,
  photo: String,
  isHybrid: Boolean,
  decodedData: Object,
  deviceInfo: Object,
  requestStatus: Number
})

const reportStatus = computed(
  () => props.status === 'third_party' || props.status === 'not_found'
)
const errorStatus = computed(
  () =>
    props.status === 'auth_error' ||
    (props.requestStatus >= 500 && props.requestStatus < 600)
)

const reopenCamera = () => {
  events.value.triggerTakePicture = true
}
</script>
